import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import i18n from "utils/i18n";
import EmployeeList from 'components/organisms/EmployeeList'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import { layoutStyles } from 'styles/layout'
import { View } from 'react-native'

const HomeCoworkerFilterResultsScene = () => {
	const navigation = useNavigation();
	const _filterResults = useSelector( state => {
		return state.data[dataConstants.FILTER_RESULTS];
	} );
	
	const openEmployee = useCallback(
		( employee ) => {
			navigation.navigate( AppRoutes.COWORKERS_VIEW, {
				employee: employee.guid
			});
		},
		[ _filterResults ]
	);
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				contentWidth="narrow"
				title={i18n.t( 'page.coworker.title' )}
				enableScrollView={ false }
				topNavigation={ true }
				showBackButton={ true }
				footerBar={ false }>
				
				<View
					style={ layoutStyles.flexOne }>
					
					<EmployeeList
						employees={ _filterResults }
						onPress={ openEmployee }
						showHeart={ true }
						showDetails={ true }
						scrollEnabled={ true }
					/>
				</View>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeCoworkerFilterResultsScene
